import { render, staticRenderFns } from "./MaterialChart.vue?vue&type=template&id=9ff0e7b2&"
import script from "./MaterialChart.vue?vue&type=script&lang=js&"
export * from "./MaterialChart.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports